export const COLORS = {
  'base-100': 'var(--color-text-base-100)',
  'icon-brand-500': 'var(--color-icon-brand-500)',
  'icon-base-500': 'var(--color-icon-base-500)',
  'bg-brand-500': 'var(--color-bg-brand-500)',
  'icon-base-300': 'var(--color-icon-base-300)',
  'contrast-500': 'var(--color-icon-contrast-500)',
  'icon-base-100': 'var(--color-icon-base-100)',
  border: 'var(--color-bg-border)',
} as const;
